import storage from 'utils/storage'

const formatOrigin = () => {
  const callbackUrl = storage.session.getItem('callbackUrl')
  const theme = storage.session.getItem('theme')

  const checkOrigin = (possibleOriginsList) => {
    return [callbackUrl, theme].filter((item) =>
      possibleOriginsList.includes(item)
    ).length
  }

  // Cross Sell Reneg
  if (checkOrigin(['renegociacao', 'reneg'])) {
    return 'Renegociação Itaú'
  }

  // Cross Sell Vitrine
  if (checkOrigin(['emprestimo', 'stg-loans', 'vitrine', 'shopping'])) {
    return 'Shopping Vitrine'
  }

  // Cross Sell Cartões
  if (checkOrigin(['cartoes', 'itaucard', 'credicard', 'iti', 'crediario'])) {
    return 'Cartões'
  }

  // Default Recovery
  if (checkOrigin(['gruporecovery', 'stg-recovery'])) {
    return 'Recovery'
  }

  return ''
}

export default {
  ['PorQueRenegociarDividas']: () => {
    return {
      site: {
        negocio: 'PF',
        tipoDeCanal: 'Web',
      },
      rule: 'pageLoad',
      transaction: {
        name: formatOrigin(),
      },
    }
  },
  ['EscolhaDivida']: () => {
    return {
      site: {
        negocio: 'PF',
        tipoDeCanal: 'Web',
      },
      rule: 'pageLoad',
      transaction: {
        name: formatOrigin(),
      },
    }
  },
  ['PagamentoDataVencimento']: () => {
    return {
      site: {
        negocio: 'PF',
        tipoDeCanal: 'Web',
      },
      rule: 'pageLoad',
      transaction: {
        name: formatOrigin(),
      },
    }
  },
  ['Revisao']: () => {
    return {
      site: {
        negocio: 'PF',
        tipoDeCanal: 'Web',
      },
      rule: 'pageLoad',
      transaction: {
        name: formatOrigin(),
      },
    }
  },
  ['DetalhesAcordo']: () => {
    return {
      site: {
        negocio: 'PF',
        tipoDeCanal: 'Web',
      },
      rule: 'pageLoad',
      transaction: {
        name: formatOrigin(),
      },
    }
  },
  ['AcordoFinalizado']: ({
    originalValueRaw,
    dueDateSelected,
    agreementId,
    partnerId,
  }) => {
    return {
      site: {
        negocio: 'PF',
        tipoDeCanal: 'Web',
      },
      rule: 'pageLoad',
      custom: {
        volsim: originalValueRaw,
        vba: dueDateSelected.payment.valueRaw,
        idproposta: agreementId,
      },
      visitor: {
        partnerid: partnerId,
      },
      transaction: {
        name: formatOrigin(),
      },
    }
  },
}
